export default {
  BASE_URL: '',
  api: [
    {
      name: 'list',
      desc: '采销合同列表',
      method: 'GET',
      path: '/tm/contract/list'
    },
    {
      name: 'detail',
      desc: '明细',
      method: 'GET',
      path: '/tm/contract/detail'
    },
    {
      name: 'edit',
      desc: '编辑',
      method: 'POST',
      path: '/tm/contract/edit'
    },
    {
      name: 'syncData',
      desc: '同步合同数据',
      method: 'POST',
      path: '/tm/contract/sync'
    },
    {
      name: 'billType',
      desc: '业务类型',
      method: 'GET',
      path: '/tm/contract/enum/billType'
    },
    {
      name: 'bindingContract',
      desc: '绑定合同--销售、采购待发货绑定合同',
      method: 'POST',
      path: '/tm/order/re/contract/connect'
    },
  ]
}


// WEBPACK FOOTER //
// ./src/api/apis/self/salesContracts/list.js